/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { OrganisationListEntryFromJSON, OrganisationListEntryToJSON, } from './OrganisationListEntry';
import { PageRequestFromJSON, PageRequestToJSON, } from './PageRequest';
/**
 * Check if a given object implements the PagedResponseOfOrganisationListEntry interface.
 */
export function instanceOfPagedResponseOfOrganisationListEntry(value) {
    var isInstance = true;
    return isInstance;
}
export function PagedResponseOfOrganisationListEntryFromJSON(json) {
    return PagedResponseOfOrganisationListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfOrganisationListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(OrganisationListEntryFromJSON)),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements']
    };
}
export function PagedResponseOfOrganisationListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasNext': value.hasNext,
        'nextPage': PageRequestToJSON(value.nextPage),
        'page': value.page,
        'entries': value.entries === undefined ? undefined : (value.entries.map(OrganisationListEntryToJSON)),
        'size': value.size,
        'metaData': MetaDataToJSON(value.metaData),
        'hasPrevious': value.hasPrevious,
        'totalElements': value.totalElements,
        'previousPage': PageRequestToJSON(value.previousPage),
        'numberOfElements': value.numberOfElements
    };
}
